module.exports = __webpack_public_path__ + "img/english.90fe46c7.png";